import {
    AINightGuardSubTypes,
    InfoSource,
    NGBiteScanTypeQuestionId,
    NGOcclusalThicknessQuestionId,
    RetainerPalateQuestionId,
} from '../constants';
import { ArchType, TreatmentInfoQuestionType, TreatmentType } from '../enums';
import { TreatmentInfoInProgressQuestion, TreatmentInfoQuestion, TreatmentInfoResponse, TreatmentInfoSection } from '../models';

export namespace TreatmentInfoUtils {
    const assetsBasePath = `assets/`;
    const occlusalThicknessImage = `${assetsBasePath}images/treatment-info/ccclusal-thickness.webp`;

    export const getQuestionProp = (treatmentTypeId: number, question: TreatmentInfoQuestion, prop: string) => {
        const infoQuestion = InfoSource.find(
            is => is.questionId === question.id && is.treatmentTypeId === treatmentTypeId
        );
        switch (prop) {
            case 'hasInfo':
                return infoQuestion ? infoQuestion.hasInfo : false;
            case 'tooltip':
                return infoQuestion ? infoQuestion.tooltip : '';
            case 'description':
                return infoQuestion ? infoQuestion.description : '';
            case 'sliderValues':
                return infoQuestion && infoQuestion.options
                    ? infoQuestion.options
                    : question.numberSliderOptions && question.numberSliderOptions.stepsArray
                      ? question.numberSliderOptions.stepsArray.map(
                            (step: { value: any; legend: any; description: any }) => ({
                                id: step.value,
                                name: step.legend,
                                showName: true,
                                isDefault: false,
                                description: step.description,
                            })
                        )
                      : [];
        }
    };

    export const getQuestionSource = (treatmentTypeId: number, question: TreatmentInfoQuestion) => {
        const infoQuestion = InfoSource.find(
            is => is.questionId === question.id && is.treatmentTypeId === treatmentTypeId
        );

        if (infoQuestion) {
            for (let i = 0; i < infoQuestion.source.length; i++) {
                const answer = question.answers[i];
                Object.assign(infoQuestion.source[i], answer, {
                    subtitle: answer.description,
                });
            }
            return infoQuestion.source;
        } else {
            return question.answers;
        }
    };

    export const getInfoQuestions = (
        {
            treatmentTypeId,
            treatmentSubTypeId,
            archType,
        }: {
            treatmentTypeId: number;
            treatmentSubTypeId: number;
            archType: ArchType;
        },
        questions: TreatmentInfoQuestion[]
    ) => {
        if (treatmentTypeId === TreatmentType.AINightGuard) {
            // Occlusal Thickness question show logic
            questions.map(c => {
                if (c.id === NGOcclusalThicknessQuestionId) {
                    c.isHidden = treatmentSubTypeId !== AINightGuardSubTypes.ClosedBite;
                    c.image = occlusalThicknessImage;
                }
            });
        }
        if (treatmentTypeId === TreatmentType.NightGuard) {
            // Occlusal Thickness question show logic
            questions.map(c => {
                if (c.id === NGOcclusalThicknessQuestionId) {
                    c.isHidden = questions.some(
                        q => q.id === NGBiteScanTypeQuestionId && +q.value !== AINightGuardSubTypes.ClosedBite
                    );
                    c.image = occlusalThicknessImage;
                }
                if (c.id === NGBiteScanTypeQuestionId) {
                    c.isHidden = false;
                }
            });
        }
        if (treatmentTypeId === TreatmentType.ManualRetainer) {
            questions.map(c => {
                if (c.id === RetainerPalateQuestionId) {
                    c.isHidden = archType === ArchType.Lower;
                }
            });
        }
        return questions;
    };

    export const initTreatmentInfoResponses = (
        options: { treatmentSubTypeId: number },
        info: TreatmentInfoSection[]
    ): TreatmentInfoResponse[] => {
        const { treatmentSubTypeId } = options;
        let treatmentInfoResponses: TreatmentInfoResponse[] = [];

        if (info?.length) {
            info.forEach(s => {
                s.questions.forEach(q => {
                    let answer: any[] = [];
                    let answerText = '';
                    if (
                        q.type === TreatmentInfoQuestionType.SingleChoice ||
                        q.type === TreatmentInfoQuestionType.SingleDropdownChoice ||
                        q.type === TreatmentInfoQuestionType.OneColSingleChoice ||
                        q.type === TreatmentInfoQuestionType.OneColSingleChoiceShowDesc ||
                        q.type === TreatmentInfoQuestionType.Toggle
                    ) {
                        answer = q.value ? [q.value] : [];
                    } else if (
                        q.type === TreatmentInfoQuestionType.MultiChoice ||
                        q.type === TreatmentInfoQuestionType.Wrapper ||
                        q.type === TreatmentInfoQuestionType.OneColMultiChoice
                    ) {
                        answer = q.answers.filter(a => a.isSelected).map(a => a.id);
                    } else {
                        answerText = q.value;
                    }

                    const infoResponse = new TreatmentInfoResponse(q.id, answer, answerText, [], q.version);

                    if (
                        (q.value || q.answers.some(a => a.isSelected)) &&
                        q.activeChildQuestions &&
                        Array.isArray(q.activeChildQuestions)
                    ) {
                        infoResponse.childAnswerResponses = initTreatmentInfoResponses(options, [
                            { name: '', description: '', questions: q.activeChildQuestions },
                        ]);
                    }
                    if (
                        treatmentSubTypeId === AINightGuardSubTypes.OpenBite &&
                        q.type === TreatmentInfoQuestionType.Slider
                    ) {
                    } else {
                        treatmentInfoResponses.push(infoResponse);
                    }
                });
            });
        }

        return treatmentInfoResponses;
    };
}
